import React, { Component } from 'react';
import { BlueBorderButton, BlueButton } from 'components/Button';
import Modal, { ModalHeader } from 'components/Modal';
import '../../styles/customStyles/meterDownloadModal.css';

import { getMeterDataLogFiles, downloadDeviceMeterData } from 'api/device';
import Table from 'components/Table';

const meterDownloadColumnDefs = [
  {
    headerName: 'Filename',
    field: 'displayName'
  }
];

class MeterDownloadModal extends Component {
  constructor(props) {
    super(props);

    this.meterDataDownloadRef = React.createRef();

    this.state = {
      encodedCsvContent: null,
      meterLogFileSelection: null,
      meterLogFiles: []
    };
  }

  async componentDidMount() {
    const { deviceId, lfdi } = this.props;

    const { files = [] } = await getMeterDataLogFiles(deviceId);
    const logs = [];
    const dateOptions = { year: 'numeric', month: 'short', day: 'numeric' };

    if (files.length > 0) {
      files.forEach(logFile => {
        // We can explect log titles to come in as `logMeterData-2021-11-19-x-x-x-deviceId.csv`, for Nov 19, 2021
        const logTitleSplit = logFile.split('-');
        const logDate = new Date(
          logTitleSplit[1],
          logTitleSplit[2] - 1,
          logTitleSplit[3]
        );
        const logTitle = logDate.toLocaleDateString(undefined, dateOptions);
        logs.push({ displayName: logTitle, fileName: logFile });
      });
      logs.sort();
    }

    const currentDate = new Date();
    const currentYear = currentDate.getUTCFullYear();
    const currentMonth = currentDate.getUTCMonth() + 1; // month is from 0 to 11
    const currentDay = currentDate.getUTCDate();
    const currentHour = currentDate.getUTCHours();
    const currentMinutes = currentDate.getUTCMinutes();
    const currentSeconds = currentDate.getUTCSeconds();
    const currentFileName = `logMeterData-${currentYear}-${currentMonth}-${currentDay}-${currentHour}-${currentMinutes}-${currentSeconds}-${lfdi}.csv`;
    const currentDisplayName = `${currentDate.toLocaleDateString(
      undefined,
      dateOptions
    )} (Current)`;
    logs.push({
      displayName: currentDisplayName,
      fileName: currentFileName,
      isCurrent: true
    });
    logs.reverse();
    this.setState({ meterLogFiles: logs });
  }

  downloadMeterData = async () => {
    const { deviceId } = this.props;
    const { meterLogFileSelection } = this.state;
    try {
      let meterDataCsv = 'data:text/csv;charset=utf-8,';
      const isCurrent = meterLogFileSelection.isCurrent;
      const meterDataCsvText = await downloadDeviceMeterData(
        deviceId,
        isCurrent,
        this.state.meterLogFileSelection.fileName
      );
      meterDataCsv += `${meterDataCsvText}`;
      const encodedCsvContent = encodeURI(meterDataCsv);

      this.setState({ encodedCsvContent }, () => {
        this.meterDataDownloadRef.current.download =
          this.state.meterLogFileSelection.fileName;
        this.meterDataDownloadRef.current.click();
      });
    } catch (err) {
      alert('ERROR: no log file to download');
    }
  };

  onSelectMeterLog = row => {
    const { displayName, fileName, isCurrent } = row.data;
    this.setState({
      meterLogFileSelection: {
        displayName: displayName,
        fileName: fileName,
        isCurrent: isCurrent
      }
    });
  };

  render() {
    const { toggleDownloadModal } = this.props;
    const { meterLogFiles, encodedCsvContent } = this.state;

    return (
      <Modal>
        {meterLogFiles.length > 0 ? (
          <>
            <ModalHeader>
              Which meter data log file would you like to download?
            </ModalHeader>
            <Table
              bigTitle="Meter Data Logs"
              rowData={meterLogFiles}
              columnDefs={meterDownloadColumnDefs}
              className="meter-download-modal-list"
              height="320px"
              width="100%"
              padding="2px"
              margin="0px"
              onRowClicked={this.onSelectMeterLog}
            />
          </>
        ) : (
          'No Files to Download'
        )}
        <div style={{ margin: '50px 0 0 5px' }}>
          <BlueBorderButton onClick={toggleDownloadModal}>
            Cancel
          </BlueBorderButton>
          {meterLogFiles.length > 0 ? (
            <BlueButton
              style={{ float: 'right' }}
              onClick={this.downloadMeterData}
            >
              Download
            </BlueButton>
          ) : (
            ''
          )}
          {encodedCsvContent ? (
            <a
              ref={this.meterDataDownloadRef}
              style={{ display: 'none' }}
              href={encodedCsvContent}
            >
              Meter Data CSV Download
            </a>
          ) : null}
        </div>
      </Modal>
    );
  }
}

export default MeterDownloadModal;
